module.exports = __webpack_public_path__ + "static/media/anne-laure-conversation-mobile.63e3e1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anne-laure-conversation-mobile.png
// module id = 2498
// module chunks = 0